export const partnersCompletenessTranslations = {
  partnersCompletenessTip: 'jbp-planning-partners-completeness-tip',
  partnersCompleteness: 'jbp-planning-partners-completeness',
}

export default partnersCompletenessTranslations
